import { CheckCircle2, Clock, FileStack, XCircle } from 'lucide-react'
import { KpiCard } from './KpiCard'
import { KpiCardGrid } from './KpiCardGrid'
import { cn } from '@/utils/cn'

export type PodStatusMetrics = {
  total: number
  pending: number
  approved: number
  rejected: number
}

export type PodStatusKpiLabels = {
  total: string
  pending: string
  approved: string
  rejected: string
}

type Props = {
  metrics: PodStatusMetrics
  labels: PodStatusKpiLabels
  refreshing?: boolean
  onTotalClick?: () => void
  onPendingClick?: () => void
  onApprovedClick?: () => void
  onRejectedClick?: () => void
  className?: string
}

export function PodStatusKpiGrid({
  metrics,
  labels,
  refreshing = false,
  onTotalClick,
  onPendingClick,
  onApprovedClick,
  onRejectedClick,
  className,
}: Props) {
  return (
    <KpiCardGrid className={cn('grid-cols-1 sm:grid-cols-2 xl:grid-cols-4', className)}>
      <KpiCard
        title={labels.total}
        count={metrics.total}
        color="#DC2925"
        icon={FileStack}
        refreshing={refreshing}
        onClick={onTotalClick}
      />
      <KpiCard
        title={labels.pending}
        count={metrics.pending}
        color="#FF7F11"
        icon={Clock}
        delay={0.05}
        refreshing={refreshing}
        onClick={onPendingClick}
      />
      <KpiCard
        title={labels.approved}
        count={metrics.approved}
        color="#06D001"
        icon={CheckCircle2}
        delay={0.1}
        refreshing={refreshing}
        onClick={onApprovedClick}
      />
      <KpiCard
        title={labels.rejected}
        count={metrics.rejected}
        color="#B71C1C"
        icon={XCircle}
        delay={0.15}
        refreshing={refreshing}
        onClick={onRejectedClick}
      />
    </KpiCardGrid>
  )
}
